import { HimuraInject } from 'himura';
import { CommonConfig } from '../configs/config.common';
import { AxiosPromise } from '../utils/axios.promise';

@HimuraInject.NamedService('GoogleTranslate')
export class GoogleTranslate {

    private translator: any;
    public configs = new CommonConfig();

    constructor() {
        const config = new CommonConfig();
        const googleTranslate = require('google-translate');
        this.translator = googleTranslate(config.googleAppKey);
    }

    /**
     *
     * @param content to translate content
     */
    public async translate(content: string, region: string): Promise<string> {
        const apiPath = this.configs.googleTranslateAPI;
        const fetched = await AxiosPromise.postJson(apiPath, {
            str: content,
            region: region
        });
        if (fetched.status === 200) {
            if (fetched.data && fetched.data.res) {
                return fetched.data.res;
            } else {
                return '';
            }
        } else {
            return '';
        }
    }
}

